export default {
  getHead: () => {
    return [{name: '학교명'}, {name: '작성일'}, {name: '재해일'}, {name: '재해구분'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).inputA_1
      case 1: return func.getContent(value).inputA_3
      case 2: return func.getContent(value).inputB_4
      case 3: return func.getContent(value).inputB_6
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.inputA_3) {
      nav.dateTarget = 'content$body.inputA_3'
      nav.dateBegin = 'nav.value.inputA_3.sDate'
      nav.dateEnd = 'nav.value.inputA_3.eDate'
    }
    return { inputA_3: nav.value.inputA_3, inputB_6: nav.value.inputB_6}
  },
  getSearchKeyword: (nav) => {
    return ['content$body.inputB_6*[:nav.page.p53.inputB_6]']
  },
}
